import React, { useState, useRef, useEffect } from "react";
import "./ProjectPage.css";
import Modal from "./Modal";
import HeaderPage from "../../components/Header/HeaderPage";
import Footer from "../../components/Footer/Footer";
import ParticleBackground from "../../components/ParticlesBg/ParticleBackground";
import ScrollToTop from "../../components/ScrollToTop/ScrollToTop";
import { FormattedMessage } from "react-intl";

const projectsData = [
  {
    id: 6,
    img: "proyecto-10.png",
    title: "Incredible India Travels",
    description: "Plan, book, and manage your trips effortlessly with our travel app—smart itineraries, best deals, and seamless global experiences.",
    shortDescription: "Travel booking platform",
    link: "https://incredible-india-travels.vercel.app/",
    technologies: [
      "https://logospng.org/download/django/django-1536.png",
      "https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original.svg",
      "https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original.svg",
      "https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-plain.svg",
      "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-original.svg",
    ],
  },
  {
    id: 7,
    img: "proyecto-7.png",
    title: "Fix Tool Electronics",
    description: "Reliable electronic repair service offering quick diagnostics, affordable fixes, skilled technicians, genuine parts, customer support, and online booking convenience.",
    shortDescription: "Electronic service website",
    link: "https://arunchy07.github.io/ChotuElectronics/",
    technologies: [
      "https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original.svg",
      "https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original.svg",
      "https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-plain.svg",
    ],
  },
  {
    id: 8,
    img: "proyecto-8.png",
    title: "Mad Libs Generator",
    description: "Developed an interactive Mad Libs project using Python that dynamically generates fun and personalized stories based on user input. Implemented a Tkinter-based GUI to allow users to enter nouns, verbs, adjectives, places, and other words, which are then inserted into randomly selected story templates.",
    shortDescription: "Interactive story generator",
    link: "https://Mad-lips.com",
    technologies: [
      "https://tse4.mm.bing.net/th/id/OIP.dJToM1TiZiJA0GYwzDHwjQHaHY?rs=1&pid=ImgDetMain&o=7&rm=3",
      "https://1.bp.blogspot.com/-2JFX5AsWbbU/Wp428R7Z0JI/AAAAAAAAEyk/Fob3mX_pLvU64_LRdLBwqBQXAX5dBERfQCLcBGAs/s1600/write-a-python-tkinter-based-desktop-app.png",
    ],
  },
  {
    id: 11,
    img: "proyecto-11.png",
    title: "Edu Manage",
    description: "A centralized listing of all government and private schools across Ghaziabad, organized by block, area, and education board. This directory includes primary, secondary, and senior secondary institutions affiliated with CBSE, ICSE, IB, and the State Board.",
    shortDescription: "School directory platform",
    link: "https://school-directory-ten.vercel.app/",
    technologies: [
      "https://creazilla-store.fra1.digitaloceanspaces.com/icons/3244252/nextjs-icon-md.png",
      "https://tse1.mm.bing.net/th/id/OIP.9QvlUFAO-Tf75Xh3rCUBRQHaIN?r=0&rs=1&pid=ImgDetMain&o=7&rm=3",
      "https://webimages.mongodb.com/_com_assets/cms/l3bt5634o9or55ovm-vercel-logotype-dark.png?auto=format%252Ccompress",
      "https://picperf.io/https://laravelnews.s3.amazonaws.com/images/tailwindcss-1633184775.jpg"
    ],
  },
  {
    id: 12,
    img: "proyecto-12.png",
    title: "BuyOro E-commerce",
    description: "An e-commerce web app in Django, Python, and MongoDB lets users browse products, manage carts, and place orders with dynamic data handling. Django powers the backend logic, while MongoDB stores flexible product and user data.",
    shortDescription: "E-commerce platform",
    link: "https://68aa8da85f3d2e1feedd7227--buyoro.netlify.app/",
    technologies: [
      "https://media.geeksforgeeks.org/wp-content/uploads/20200210175202/django-basics.png",
      "https://tecnoticias.net/wp-content/uploads/2021/02/mongodb-atlas-google-cloud-partnership-nosql-databases-integrations-2.jpg",
      "https://logos-world.net/wp-content/uploads/2021/10/Python-Logo.png",
      "https://tse1.mm.bing.net/th/id/OIP.St5crFq6GyphKeEs6ak96wHaCf?r=0&rs=1&pid=ImgDetMain&o=7&rm=3"
    ],
  },
  {
    id: 14,
    img: "proyecto-14.png",
    title: "VocabMate Dictionary",
    description: "A modern dictionary web app built with React and styled using CSS, powered by a FastAPI backend. It allows users to search for word meanings, pronunciations, and definitions in multiple languages with real-time results and a user-friendly interface.",
    shortDescription: "Modern dictionary application",
    link: "https://dictionary-sigma-eight.vercel.app",
    technologies: [
      "https://media.geeksforgeeks.org/wp-content/uploads/20231122102833/reactImage.png",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1200px-CSS3_logo_and_wordmark.svg.png",
      "https://tse1.mm.bing.net/th/id/OIP.dpXAaEpwsJcs2UbZEp5jJwHaDt?r=0&rs=1&pid=ImgDetMain&o=7&rm=3"
    ],
  },
  {
    id: 13,
    img: "proyecto-13.png",
    title: "BookVault Library",
    description: "BookVault is a modern web application built with React.js that allows users to browse, search, and manage books. It connects to a FastAPI backend with MongoDB, providing a seamless interface for viewing book details, ratings, and categories.",
    shortDescription: "Book management application",
    link: "https://book-vault-frontend-bay.vercel.app/",
    technologies: [
      "https://media.geeksforgeeks.org/wp-content/uploads/20200210175202/django-basics.png",
      "https://tecnoticias.net/wp-content/uploads/2021/02/mongodb-atlas-google-cloud-partnership-nosql-databases-integrations-2.jpg",
      "https://logos-world.net/wp-content/uploads/2021/10/Python-Logo.png",
      "https://tse1.mm.bing.net/th/id/OIP.St5crFq6GyphKeEs6ak96wHaCf?r=0&rs=1&pid=ImgDetMain&o=7&rm=3"
    ],
  },
];

const proyectsImg = require.context("../../img", true);

const Project = () => {
  const [modalState, setModalState] = useState({
    isOpen: false,
    selectedProject: null,
  });
  const [filter, setFilter] = useState("all");
  const modalRef = useRef(null);

  const openModal = (project) => {
    setModalState({
      isOpen: true,
      selectedProject: project,
    });
  };

  useEffect(() => {
    if (modalState.isOpen && modalRef.current) {
      // Scroll to the modal with smooth behavior
      setTimeout(() => {
        modalRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 10);
    }
  }, [modalState.isOpen]);

  const closeModal = () => {
    setModalState({
      isOpen: false,
      selectedProject: null,
    });
  };

  const ProjectCard = ({ project, onOpenModal }) => {
    return (
      <div className="project-card" onClick={() => onOpenModal(project)}>
        <div className="project-image-container">
          <img
            src={proyectsImg(`./${project.img}`)}
            alt={project.title}
            className="project-image"
          />
          <div className="project-overlay">
            <div className="project-info">
              <h3 className="project-title">{project.title}</h3>
              <p className="project-description">{project.shortDescription}</p>
              <button className="project-view-btn">View Details</button>
            </div>
          </div>
        </div>
        <div className="project-card-footer">
          <h4 className="project-card-title">{project.title}</h4>
          <div className="tech-icons-mini">
            {project.technologies.slice(0, 3).map((techUrl, index) => (
              <img key={index} src={techUrl} alt="Tech icon" className="tech-icon-mini" />
            ))}
            {project.technologies.length > 3 && (
              <span className="more-tech">+{project.technologies.length - 3} more</span>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="projects-page">
      <HeaderPage />
      <ParticleBackground />
      
      <div className="projects-hero">
        <div className="container">
          <h1 className="projects-main-title">
            <FormattedMessage id="projects-title" defaultMessage="My Projects" />
          </h1>
          <div className="title-underline"></div>
          <p className="projects-subtitle">
            <FormattedMessage 
              id="projects-subtitle" 
              defaultMessage="A collection of my recent work and creative projects" 
            />
          </p>
        </div>
      </div>

      <main className="projects-container">
        <div className="container">
          <div className="projects-filter">
            <button 
              className={`filter-btn ${filter === 'all' ? 'active' : ''}`}
              onClick={() => setFilter('all')}
            >
              All Projects
            </button>
            <button 
              className={`filter-btn ${filter === 'web' ? 'active' : ''}`}
              onClick={() => setFilter('web')}
            >
              Web Development
            </button>
            <button 
              className={`filter-btn ${filter === 'app' ? 'active' : ''}`}
              onClick={() => setFilter('app')}
            >
              Applications
            </button>
          </div>

          <div className="projects-grid">
            {projectsData.map((project) => (
              <ProjectCard key={project.id} project={project} onOpenModal={openModal} />
            ))}
          </div>
        </div>
      </main>

      {modalState.selectedProject && (
        <div ref={modalRef}>
          <Modal estado={modalState.isOpen} cambiarEstado={closeModal}>
            <div className="modal-content">
              <div className="modal-header">
                <h2>{modalState.selectedProject.title}</h2>
                <button className="modal-close-btn" onClick={closeModal}>
                  &times;
                </button>
              </div>
              <div className="modal-body">
                <div className="modal-image">
                  <img
                    src={proyectsImg(`./${modalState.selectedProject.img}`)}
                    alt={modalState.selectedProject.title}
                  />
                </div>
                <div className="modal-details">
                  <p className="modal-description">
                    {modalState.selectedProject.description}
                  </p>
                  <div className="project-link">
                    <span>Live Demo: </span>
                    <a href={modalState.selectedProject.link} target="_blank" rel="noreferrer">
                      {modalState.selectedProject.link}
                    </a>
                  </div>
                  <div className="technologies-used">
                    <h4>Technologies Used:</h4>
                    <div className="tech-icons">
                      {modalState.selectedProject.technologies.map((techUrl, index) => (
                        <img key={index} src={techUrl} alt="Technology icon" className="tech-icon" />
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        </div>
      )}

      <ScrollToTop />
      <Footer />
    </div>
  );
};

export default Project;